export const EVOLUTION_STEP_UP_TO_VOTE = 'STEP_LIVE_FOR_VOTE';
export const EVOLUTION_STEP_FEATURE_PREVIEW = 'STEP_PROTOTYPE';
export const EVOLUTION_STEP_RELEASE = 'STEP_RELEASE';
export const EVOLUTION_STEP_SURVEY = 'SURVEY';
